export default __webpack_public_path__ + "static/media/reserveSpot.e47bf752.png";